import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './styles.css'

const DayDisplay = ({ day, index, handleChange, }) => {
  return (
    <div>
      <input
        type="text"
        className="day-descr"
        name={`day${index}`}
        value={day.descr}
        onChange={handleChange}
      />
    </div>
  )
}

class EventItinerary extends Component {

  static propTypes = {
    tripId: PropTypes.string.isRequired,
    locationId: PropTypes.string.isRequired,
    fromDate: PropTypes.string.isRequired,
    toDate: PropTypes.string.isRequired,
    itinerary: PropTypes.arrayOf(
      PropTypes.shape({
        descr: PropTypes.string,
      })
    ),
    saveItinerary: PropTypes.func.isRequired,
  }

  static defaultProps = {
    itinerary: [],
  }

  state = {
    itinerary: [],
    unsavedChanges: false,
  }

  componentWillMount() {
    this.setStateFromProps({ props: this.props, })
  }

  componentWillReceiveProps(nextProps) {
    this.setStateFromProps({ props: nextProps, })
  }

  setStateFromProps = ({ props, }) => {
    const { itinerary, fromDate, toDate, } = props
    // take a deep copy of the itinerary array to ensure we do not update the
    // original itinerary item references
    const thisItinerary = itinerary.map(a => ({ ...a, }))
    const duration = moment(toDate).diff(moment(fromDate), 'days') + 1
    const itineraryDays = []
    let i = 0
    let itineraryDay
    while (i < duration) {
      if (thisItinerary && thisItinerary[i]) {
        itineraryDay = thisItinerary[i]
      } else {
        itineraryDay = {
          descr: 'TBC',
        }
      }
      // set date here (as we do not trust what may have already been set in source data)
      // array order is assumed to be KING here
      itineraryDay.date = moment(fromDate).add('days', i).format('YYYY-MM-DD')
      itineraryDays.push(itineraryDay)
      i += 1
    }
    this.setState({
      itinerary: itineraryDays,
      unsavedChanges: false,
    })
  }

  handleChange = (event) => {
    const { itinerary, } = this.state
    const dayIndex = Number(event.target.name.substr(3))
    const thisItinerary = itinerary.map(a => ({ ...a, }))
    thisItinerary[dayIndex].descr = event.target.value
    // TODO: consider making check for unsaved changes a bit more clever
    this.setState({
      itinerary: thisItinerary,
      unsavedChanges: true,
    })
  }

  saveChanges = () => {
    const { itinerary, } = this.state
    const { tripId, locationId, saveItinerary, } = this.props
    saveItinerary({
      tripId,
      locationId,
      itinerary,
    })
  }

  render() {
    const { handleChange, saveChanges, } = this
    const { itinerary, unsavedChanges, } = this.state
    return (
      <div className="EditTrip-EventItinerary">
        {itinerary.map((day, index) => (
          <DayDisplay
            key={day.date}
            day={day}
            index={index}
            handleChange={handleChange}
          />
        ))}
        {unsavedChanges &&
          <button onClick={saveChanges}>save changes</button>
        }
      </div>
    )
  }
}

export default EventItinerary



// WEBPACK FOOTER //
// ./src/components/EditTrip/EventItinerary/component.js